import { useTranslation } from "react-i18next";
import { Checkbox } from "../../../../fields/base/Checkbox";
import { css } from "../../../../../../styled-system/css";
import { Grid } from "../../../../../../styled-system/jsx";
import { HoverInfo } from "../../../basic/Tooltip";
import { AMAZON_BUSINESS_SITE_RESTRICTION } from "../constants";

const AmazonSiteRestrictionsField = ({ state, onChange, review, readOnly }) => {
  const { t } = useTranslation(["advertising"]);
  const isChecked = state.siteRestrictions === AMAZON_BUSINESS_SITE_RESTRICTION;

  return (
    <>
      <h3 className={css({ fontWeight: 600, fontSize: "1.6rem", color: "#73706E" })}>
        {t(($) => $.advertising["Sites:"])}
      </h3>

      <Grid columns={{ base: 1, md: 12 }} className={css({ paddingBlock: "small" })}>
        <div className={css({ gridColumn: { md: "span 5" }, padding: "small", display: "flex", gap: "small" })}>
          <Checkbox
            label={t(($) => $.advertising["Restrict to Amazon Business"])}
            value={isChecked}
            isDisabled={readOnly || review}
            onChange={(checked) => {
              onChange({
                siteRestrictions: checked ? AMAZON_BUSINESS_SITE_RESTRICTION : null,
              });
            }}
          />
          {review && (
            <HoverInfo iconCss={{ color: "grey", display: "inline" }}>
              {t(($) => $.advertising["This field can only be set during media plan creation"])}
            </HoverInfo>
          )}
        </div>
        <div className={css({ gridColumn: { md: "span 7" }, paddingTop: "medium" })}>
          <p
            className={css({
              color: "text.secondary",
              fontSize: "small",
              fontWeight: 500,
            })}
          >
            {t(
              ($) =>
                $.advertising[
                  "Show ads only to business shoppers on Amazon Business to support B2B-focused campaigns."
                ],
            )}
          </p>
        </div>
      </Grid>
    </>
  );
};

export { AmazonSiteRestrictionsField };
